import React, { FC, memo, useCallback } from 'react';
import { IDataGridFilter } from '../../model';
import { Select } from 'AurionCR/components/form/select';
import { useFiltersSheetSettings } from 'components/filters-dialog/context';

export const calcFilterSelectResult = (value: any, field: string) => {
  if (value) {
    if (Array.isArray(value) && value.length) {
      const result = value.reduce((result: any[], item: any) => {
        if (item[field]) result.push(item[field]);
        return result;
      }, []);
      return result.length ? result : '';
    } else {
      return value[field] || '';
    }
  }
  return '';
};

const FilterSelect: FC<React.PropsWithChildren<{
  filter: IDataGridFilter;
  value: any;
  onTasks: any;
}>> = ({ filter, value, onTasks }) => {
  const onChange = useCallback((e: any, value: any) => {
    onTasks([
      ['pagination', { page: 1 }],
      // @ts-ignore
      ['filters', { [filter.field]: calcFilterSelectResult(value, filter.options.option.value) }],
      ['getData'],
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // N2 (T5, DC-18 a): in the filters sheet (below md) an empty select reads
  // "all" (the grid's default placeholder is "select")
  const settings = useFiltersSheetSettings(filter.options);
  return (
    <Select
      // @ts-ignore
      settings={settings}
      style={filter.options?.style}
      value={value}
      onChange={onChange}
    />
  );
};

export default memo(FilterSelect);
